


const API_VERSION_STATUS_REQUEST = 'API_VERSION_STATUS_REQUEST';
const RESET_CODE_REQUEST = 'RESET_CODE_REQUEST';
const API_VERSION_STATUS_SUCCESS = 'API_VERSION_STATUS_SUCCESS';
const API_VERSION_STATUS_FAILURE = 'API_VERSION_STATUS_FAILURE';
const SET_VERSION_STATUS = 'SET_VERSION_STATUS';





export const versionStatusRequest = payload => ({
  type: API_VERSION_STATUS_REQUEST,
  payload: payload
});

export const setVersionStatus = payload => ({
  type: SET_VERSION_STATUS,
  payload: payload
});

export const versionStatusSuccess = payload => ({
  type: API_VERSION_STATUS_SUCCESS,
  payload,
});

export const versionStatusFailure = payload => ({
  type: API_VERSION_STATUS_FAILURE,
  payload,
});

export const resetCodeRequest = payload => ({
  type: RESET_CODE_REQUEST,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  message:null,
  status:null
};

export function versionStatusReducer(state = initialState, action) {
 
  switch (action.type) {
    case API_VERSION_STATUS_REQUEST:
    return {
      ...state,
      fetching: true,
      isFetched: false,
    };
    case SET_VERSION_STATUS:
        return {
          ...state,
          status: action.payload
        };
    case RESET_CODE_REQUEST:
    return {
      ...state,
      codeMessage: null
    };
     
    case API_VERSION_STATUS_SUCCESS:
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        message: action.payload
      };
    case API_VERSION_STATUS_FAILURE:

      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
